import { render, staticRenderFns } from "./DialogShowCourseDetails.vue?vue&type=template&id=23983dc2&scoped=true&"
import script from "./DialogShowCourseDetails.vue?vue&type=script&lang=js&"
export * from "./DialogShowCourseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23983dc2",
  null
  
)

export default component.exports